var map = {
	"./ico-1-w.svg": 106,
	"./ico-1.svg": 90574,
	"./ico-2-w.svg": 85169,
	"./ico-2.svg": 38925,
	"./ico-3-w.svg": 50540,
	"./ico-3.svg": 39980,
	"./ico-4-w.svg": 57259,
	"./ico-4.svg": 73875,
	"./ico-5-w.svg": 80302,
	"./ico-5.svg": 68706,
	"./ico-6-w.svg": 92229,
	"./ico-6.svg": 89073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23063;